




import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {TokenPriced} from '@/model/resource/TokenPriced'
import {TextHelper} from '@/helpers/TextHelper'

@Component
export default class OrbitAmountInput extends Vue {
  @Prop({type: TokenPriced, required: true}) token!: TokenPriced
  @Prop({type: String, default: null}) amount!: string | null

  internalValue: string = ''

  sanitize(raw: string, tokenDecimals: number) {
    let value = raw ?? ''

    value = value.replace(/[eE]/g, '').trim()

    value = value.replace(/,/g, '.')

    if (tokenDecimals === 0) {
      value = value.replace(/\D/g, '')
      return value.slice(0, 30)
    }

    value = value.replace(/[^0-9.]/g, '')

    const dot = value.indexOf('.')
    if (dot !== -1) {
      const beforeDot = value.slice(0, dot)
      let afterDot = value.slice(dot + 1).replace(/\./g, '')

      if (afterDot.length > tokenDecimals) {
        afterDot = afterDot.slice(0, tokenDecimals)
      }

      value = beforeDot + '.' + afterDot
    }

    return value.slice(0, 60)
  }

  mounted() {
    if (this.amount && this.token.decimals) {
      this.internalValue = TextHelper.toFullNumber(
        this.amount,
        this.token.decimals
      )
    } else {
      this.internalValue = ''
    }
  }

  @Watch('amount')
  onAmountChanged(newVal: string | null) {
    if (newVal == null) {
      this.internalValue = ''
      return
    }

    const tokenDecimals = this.token.decimals ?? 0
    this.internalValue = this.sanitize(
      TextHelper.toFullNumber(newVal, tokenDecimals),
      tokenDecimals
    )
  }

  @Watch('token')
  onTokenChanged() {
    if (!this.internalValue) {
      this.internalValue = ''
      this.$emit('input', '')
      return
    }

    const tokenDecimals = this.token.decimals ?? 0
    const normalized = this.sanitize(
      TextHelper.toFullNumber(this.internalValue, tokenDecimals),
      tokenDecimals
    )

    this.internalValue = normalized
    this.$emit('input', normalized)
  }

  handleKeydown(event: KeyboardEvent) {
    const tokenDecimals = this.token.decimals ?? 0

    if (tokenDecimals === 0 && (event.key === '.' || event.key === ',')) {
      event.preventDefault()
      return
    }

    if (event.key === ',') {
      event.preventDefault()
      return
    }

    if (event.key.toLowerCase() === 'e') {
      event.preventDefault()
      return
    }
  }

  handleInput(event: Event) {
    const element = event.target as HTMLInputElement
    const tokenDecimals = this.token.decimals ?? 0
    const sanitized = this.sanitize(element.value, tokenDecimals)

    if (element.value !== sanitized) {
      element.value = sanitized
    }

    this.internalValue = sanitized
    this.$emit('input', sanitized)
  }
}
